module.exports = __webpack_public_path__ + "static/media/bar2.7c737800.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floorPlan/bar2.svg
// module id = 1124
// module chunks = 38